import gsap from 'gsap';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const ClassName = {
	LIMITED: '_limited',
	SHOWED: '_showed',
	ACTIVE: '_active',
};

class ProductInfo {
	constructor() {
		this.sliderInstances = new Map();
		this.init();
	}

	init() {
		const container = document.querySelector('.product-info');

		if (!container) {
			return;
		}

		this.id = 1;
		const gallerys = container.querySelectorAll('[data-product-gallery]');
		const galleryWrapper = container.querySelector(
			'[data-product-gallery-wrapper]',
		);
		const previews = container.querySelectorAll('[data-product-preview-slide]');

		const initSlider = (swiperContainer) => {
			if (this.sliderInstances.has(swiperContainer)) {
				return;
			}

			const galleryWrapper = swiperContainer.querySelector(
				'[data-product-gallery-wrapper]',
			);
			const nextButton = swiperContainer.querySelector(
				'[data-nav-button-next]',
			);
			const prevButton = swiperContainer.querySelector(
				'[data-nav-button-prev]',
			);
			const pagination = swiperContainer.querySelector('.swiper-pagination');
			let slides = swiperContainer.querySelectorAll('.swiper-slide');

			if (!swiperContainer.classList.contains('slides-cloned')) {
				slides = swiperContainer.querySelectorAll('.swiper-slide');

				if (slides.length < 3) {
					const slidesToDuplicate = Array.from(slides);
					while (slides.length < 4) {
						slidesToDuplicate.forEach((slide) => {
							if (slides.length >= 4) return;
							const clonedSlide = slide.cloneNode(true);
							galleryWrapper.appendChild(clonedSlide);
							slides = swiperContainer.querySelectorAll('.swiper-slide');
						});
					}
					swiperContainer.classList.add('slides-cloned');
				}
			}

			const slider = new Swiper(swiperContainer, {
				spaceBetween: 10,
				slidesPerView: 'auto',
				centeredSlides: true,
				loop: true,
				modules: [Navigation, Pagination],
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
				},
				pagination: {
					el: pagination,
				},
			});

			this.sliderInstances.set(swiperContainer, slider);
		};

		const initialGallery = container.querySelector(
			'[data-product-gallery]._active',
		);
		const swiperSlider = initialGallery.querySelector('.swiper');
		initSlider(swiperSlider);

		previews.forEach((preview) => {
			preview.addEventListener('click', () => {
				this.id = preview.dataset.productPreviewSlide;

				previews.forEach((prev) => prev.classList.remove(ClassName.ACTIVE));
				document
					.querySelector(`[data-product-preview-slide="${this.id}"]`)
					.classList.add(ClassName.ACTIVE);

				gallerys.forEach((gallery) => {
					gallery.classList.remove(ClassName.ACTIVE);
				});
				const activeGallery = gallerys[this.id - 1];
				activeGallery.classList.add(ClassName.ACTIVE);

				const newSwiperSlider = activeGallery.querySelector('.swiper');
				initSlider(newSwiperSlider);

				galleryWrapper.dataset.numberImage = this.id;
			});
		});

		this.showAllPreviews(container);
		this._initButtons(container);
		this._initFixedActions(container);
	}

	showAllPreviews(container) {
		const button = container.querySelector('[data-show-preview]');
		if (!button) return;

		const textElement = button.querySelector('span');
		const previewContainer = container.querySelector('[data-product-preview]');

		const showText = textElement.textContent;
		const hideText = button.dataset.hideText;

		button.addEventListener('click', () => {
			textElement.textContent =
				textElement.textContent === showText ? hideText : showText;
			previewContainer.classList.toggle(ClassName.LIMITED);
			button.classList.toggle(ClassName.SHOWED);
		});
	}
	_initButtons(container) {
		const addToCart = container.querySelector('.product-details__add-to-cart');
		const addToFavorite = container.querySelector('.product-details__favorite');

		if (!addToCart || !addToFavorite) {
			return;
		}

		const cartCount = document.querySelector(
			'.header__action._shopping .header__action-count',
		);
		const favoritesCount = document.querySelector(
			'.header__action._favorites .header__action-count',
		);

		addToCart.addEventListener('click', () => {
			cartCount.classList.add('_bounce');
			clearTimeout(cartCount.TO);
			cartCount.TO = setTimeout(() => {
				cartCount.classList.remove('_bounce');
			}, 600);
		});
		addToFavorite.addEventListener('click', () => {
			const isActive = addToFavorite
				.querySelector('svg')
				.classList.contains('_active');

			if (isActive) {
				return;
			}
			favoritesCount.classList.add('_bounce');
			clearTimeout(favoritesCount.TO);
			favoritesCount.TO = setTimeout(() => {
				favoritesCount.classList.remove('_bounce');
			}, 600);
		});
	}
	_initFixedActions(container) {
		const actions = container.querySelector('.section-mobile._actions');
		const fixedActions = container.querySelector(
			'.section-mobile._fixed-actions',
		);
		const fixedHeader = document.querySelector('.hero._product');

		if (!actions || !fixedActions || !fixedHeader) {
			return;
		}

		const onWindowResize = () => {
			if (window.innerWidth > 640) {
				fixedActions.removeAttribute('style');
			} else {
				gsap.set(fixedActions, {
					autoAlpha: 1,
				});
				gsap.fromTo(
					fixedActions,
					{
						yPercent: 100,
					},
					{
						yPercent: 0,
						duration: 0.15,
						scrollTrigger: {
							trigger: actions,
							start: `bottom top+=${fixedHeader.offsetHeight}px`,
							toggleActions: 'play none none reverse',
						},
					},
				);
			}
		};

		onWindowResize();
	}
}

export default new ProductInfo();
